/* ヘッダー: サイドバー開閉・検索・SP時のアイコン退避。
   要素が無い構成でも例外で止まらないよう、各参照を null ガードする。 */
(function () {
  var hamburgers = Array.from(document.querySelectorAll(".hamburger"));
  var sidebarBg = document.querySelector(".sidebar-bg");
  var sidebar = document.querySelector(".sidebar");
  var sidebarClose = document.querySelector(".sidebar-tenant-collapse");
  var body = document.body;
  var searchBtn = Array.from(document.querySelectorAll(".search-btn"));
  var searchForm = document.querySelector(".search-form");
  var searchFormClose = document.querySelector(".search-form__close");

  function openSidebar() {
    if (sidebarBg) sidebarBg.classList.add("open");
    if (sidebar) sidebar.classList.add("open");
    body.classList.add("sidebar-is-open");
    body.style.overflow = "hidden";
  }

  function closeSidebar() {
    if (sidebarBg) sidebarBg.classList.remove("open");
    if (sidebar) sidebar.classList.remove("open");
    body.classList.remove("sidebar-is-open");
    body.style.overflow = null;
  }

  hamburgers.forEach(function (hamburger) {
    hamburger.addEventListener('click', function () {
      if (sidebar && sidebar.classList.contains("open")) {
        closeSidebar();
      } else {
        openSidebar();
      }
    });
  });

  if (sidebarBg) {
    sidebarBg.addEventListener('click', function () {
      closeSidebar();
    });
  }

  if (sidebarClose) {
    sidebarClose.addEventListener('click', function () {
      closeSidebar();
    });
  }

  if (searchFormClose) {
    searchFormClose.addEventListener('click', function (event) {
      if (searchForm) searchForm.classList.remove("open");
      event.stopPropagation();
    });
  }

  if (searchForm) {
    searchForm.addEventListener('click', function (event) {
      event.stopPropagation();
    });
  }

  body.addEventListener('click', function (event) {
    if (searchBtn.some(function (btn) { return btn.contains(event.target); })) {
      return;
    }
    if (searchForm && searchForm.classList.contains("open")) {
      searchForm.classList.remove("open");
    }
  });

  searchBtn.forEach(function (element) {
    element.addEventListener('click', function (event) {
      if (searchForm && !searchForm.classList.contains("open")) {
        searchForm.classList.add("open");
      }
      event.stopPropagation();
    });
  });

  /* ===== SP 時にヘッダーアイコンをメニュー(サイドバー)内へ退避 =====
     各アイコンブロックの「SP時の配置」で menu を選んだ要素を、SP 幅では
     サイドバー内 [data-sidebar-actions] へ移動し、PC 幅では元の位置へ戻す。
     元位置はコメントノードのプレースホルダで保持するため並び順が維持される。
     (hidden は CSS のみで非表示。header は常時ヘッダー表示のため対象外。) */
  (function () {
    var target = document.querySelector('[data-sidebar-actions]');
    var actions = Array.from(
      document.querySelectorAll('.tgtp-header-action[data-sp-placement="menu"]')
    );
    if (!target || !actions.length) return;

    var items = actions.map(function (el) {
      return { el: el, placeholder: document.createComment('header-action') };
    });
    var mq = window.matchMedia('(max-width: 749px)');

    function apply(isMobile) {
      items.forEach(function (item) {
        if (isMobile) {
          if (item.el.parentNode !== target) {
            item.el.parentNode.insertBefore(item.placeholder, item.el);
            target.appendChild(item.el);
          }
        } else if (item.placeholder.parentNode) {
          item.placeholder.parentNode.insertBefore(item.el, item.placeholder);
          item.placeholder.parentNode.removeChild(item.placeholder);
        }
      });
    }

    apply(mq.matches);
    if (mq.addEventListener) {
      mq.addEventListener('change', function (e) { apply(e.matches); });
    } else if (mq.addListener) {
      mq.addListener(function (e) { apply(e.matches); });
    }
  })();
})();
